<div id="app-table-layer" style="position: absolute; width: 100%; height: 100%; overflow: hidden;">
  <game-table></game-table>
</div>
<ui-panel *ngIf="myPeer.MenuVisible == true" [top]="0" [left]="0" [width]="100" [height]=height [title]="'Menu'">
  <nav>
    <ul>
      <!--<li *ngIf="!isConvention && !isOrganizer" (click)="open('')">
    <a href="https://tonamel.com/competition/Fd1TC" target="_blank">
      <div class="important">
        <is class="sico-satellite"></is>
      </div>
      <div class="important">大会情報</div>
    </a>
  </li>-->
      <li (click)="open('PeerMenuComponent')" title="メインメニュー">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fas fa-user-plus"></i></div>
        </a>
      </li>
      <li (click)="open('ChatWindowComponent')" title="チャット画面">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fas fa-comments"></i></div>
        </a>
      </li>
      <!--<li *ngIf="isRaijinmode && !isRaijin" (click)="Raijinmodechange()">
    <a>
      <div><i class="fas fa-cloud"></i></div>
      <div>雷轟戦モード</div>
    </a>
  </li>
  <li *ngIf="isRaijinmode && isRaijin" (click)="Raijinmodechange()">
    <a>
      <div><i class="fas fa-poo-storm"></i></div>
      <div>雷神戦モード</div>
    </a>
  </li>
  <li *ngIf="!isConvention" (click)="reset()">
    <a>
      <div><i class="fas fa-bolt"></i></div>
      <div>対戦を始める</div>
    </a>
  </li>-->
      <!-- <li *ngIf="!isSaveing" (click)="save()">
        <a>
          <div><i class="fas fa-clipboard"></i></div>
          <div>結果報告</div>
        </a>
      </li> -->
      <li *ngIf="!isConvention" (click)="chessclock()" title="時計を操作する">
        <a>
          <div><i class="fas fa-hourglass-start"></i></div>
        </a>
      </li>
      <li (click)="open('')" title="ルールブック">
        <a href="https://raigonarium.velvet.jp/RediGames/rulebook/viewer/index.html" target="_blank">
          <div><i class="fas fa-book-open"></i></div>
        </a>
      </li>
      <li (click)="open('JukeboxComponent')" title="音量調整">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fas fa-volume-up"></i></div>
        </a>
      </li>
      <!--<li *ngIf="!isGuide" (click)="Guidemodechange()">
    <a>
      <div><i class="fas fa-bell-slash"></i></div>
      <div>ガイド機能オフ</div>
    </a>
  </li>
  <li *ngIf="isGuide" (click)="Guidemodechange()">
    <a>
      <div><i class="fas fa-bell"></i></div>
      <div>ガイド機能オン</div>
    </a>
  </li>-->
      <li *ngIf="isOrganizer" (click)="open('GameTableSettingComponent')" title="テーブル設定">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fas fa-layer-group"></i></div>
        </a>
      </li>
      <li *ngIf="!isConvention && !isgodeye" (click)="Godeyemodechange()" title="観戦機能オフ">
        <a>
          <div><i class="far fa-eye-slash"></i></div>
        </a>
      </li>
      <li *ngIf="!isConvention && isgodeye" (click)="Godeyemodechange()" title="観戦機能オン">
        <a>
          <div><i class="far fa-eye"></i></div>
        </a>
      </li>
      <!--*ngIf="isOrganizer"-->
      <li *ngIf="isOrganizer" (click)="open('FileStorageComponent')" title="画像">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fas fa-images"></i></div>
        </a>
      </li>
      <!--<li *ngIf="isOrganizer" (click)="open('GameObjectInventoryComponent')">
    <a routerLink="/" routerLinkActive="active">
      <div><i class="fas fa-folder"></i></div>
      <div>インベントリ</div>
    </a>
  </li>-->
      <li *ngIf="isOrganizer" title="ZIP読込">
        <a routerLink="/" routerLinkActive="active">
          <label>
            <div><i class="fas fa-file-import"></i></div>
            <input type="file" style="display: none;" (change)="handleFileSelect($event)" multiple
              accept="application/xml,text/xml,application/zip" />
          </label>
        </a>
      </li>
      <li *ngIf="!isSaveing" (click)="save()" title="保存">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fa-solid fa-cloud-arrow-up"></i></div>
        </a>
      </li>
      <li *ngIf="isSaveing" style="pointer-events: none;" title="保存中">
        <a>
          <div><i class="material-icons vibration-amine">sd_storage</i></div>
          <!-- <div>{{progresPercent}}%</div> -->
        </a>
      </li>
      <!-- <li (click)="tweet()" title="結果をツイート">
        <a>
          <div><i class="fab fa-twitter"></i></div>
        </a>
      </li> -->
      <!-- <li (click)="JudgeCall()">
        <a>
          <div><i class="fas fa-phone-alt"></i></div>
          <div>運営を呼ぶ</div>
        </a>
      </li> -->
      <!--<li *ngIf="!isConvention" (click)="textfileDownload()">
    <a>
      <div><i class="fas fa-save"></i></div>
      <div>結果を保存</div>
    </a>
  </li>-->
      <li *ngIf="!isConvention" (click)="open('')" title="公式サイト">
        <a href="https://www.raigonarium.org/RediGames/" target="_blank">
          <i class="fas fa-home"></i>
        </a>
      </li>
      <li (click)="open('TournamentBoardComponent')" title="大会ボード">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fa-solid fa-bolt important"></i></div>
        </a>
      </li>
      <!-- <li (click)="openSheetApiCheck()" title="通信確認">
        <a routerLink="/" routerLinkActive="active">
          <div><i class="fas fa-network-wired"></i></div>
        </a>
      </li> -->
    </ul>
  </nav>
</ui-panel>

<div class="success-overlay" *ngIf="isSaveSuccess">
  <div class="lightning-container">
    <div class="lightning-bolt bolt-1"></div>
    <div class="lightning-bolt bolt-2"></div>
    <div class="lightning-bolt bolt-3"></div>
  </div>
  <div class="cherry-blossom-container">
    <div class="petal" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]"></div>
  </div>
  <div class="success-content">
    <div class="success-icon"><i class="fas fa-check-circle"></i></div>
    <div class="success-text">アップロードを完了しました</div>
  </div>
</div>
<div #modalLayer></div>
<div #cursorTooltip class="cursor-tooltip"></div>
<network-indicator class="networkIndicator"></network-indicator>